import React from "react"
import classnames from "classnames";
import externalLinkIcon from "../../images/icon-external-link.png"

const component = (props) =>
  <a
    target="_blank"
    href="https://www.on-site.com/apply/property/201823"
    aria-label="Apply Now"
    className={classnames('button button--primary button--elongated button--icon-right', props.className)}
  >
    Apply Now <img alt="Apply Now Icon" src={externalLinkIcon} className="button--icon-right__icon" alt="" />
  </a>

component.displayName = "ApplyNowButton";
export default component;


// WEBPACK FOOTER //
// ./client/components/ApplyNowButton/index.js